module.exports = __webpack_public_path__ + "img/edge_activites_guide.01502a88.svg";